export interface SpecialItem {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  cover: string;
  color: string;
}

export const specials: SpecialItem[] = [
  {
    id: "s1",
    title: "近期热播榜单",
    subtitle: "每周更新 · 全网热度追踪",
    description: "汇聚当下讨论度最高的电影与电视剧，跟随热度榜单第一时间追上热门话题，不再错过任何一部爆款作品。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20dark%20cinema%20theater%20interior%20with%20glowing%20screen%20and%20empty%20red%20seats%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20no%20text&width=1200&height=700&seq=qx-special-s1&orientation=landscape",
    color: "primary",
  },
  {
    id: "s2",
    title: "治愈系暖片合辑",
    subtitle: "温柔以待 · 慢下来的时光",
    description: "为疲惫的你准备的一份温柔片单，爱情、亲情与成长交织，适合在安静的夜晚慢慢品味的治愈之作。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20warm%20cinematic%20scene%20of%20a%20messy%20blanket%20and%20mug%20by%20a%20window%20at%20golden%20hour%2C%20soft%20warm%20orange%20and%20deep%20navy%20tones%2C%20gentle%20lighting%2C%20film%20grain%2C%20no%20text&width=1200&height=700&seq=qx-special-s2&orientation=landscape",
    color: "accent",
  },
  {
    id: "s3",
    title: "口碑大片精选",
    subtitle: "高分之作 · 值得一看再看",
    description: "由资深影迷甄选的年度高口碑大片，恢弘制作与深刻叙事兼备，每一部都值得在大屏上郑重观看。",
    cover: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20mountain%20landscape%20at%20sunset%20with%20dramatic%20clouds%2C%20deep%20navy%20blue%20and%20fiery%20orange%20color%20grading%2C%20grand%20lighting%2C%20film%20grain%2C%20no%20text&width=1200&height=700&seq=qx-special-s3&orientation=landscape",
    color: "primary",
  },
  {
    id: "s4",
    title: "悬疑烧脑专场",
    subtitle: "抽丝剥茧 · 一集入坑",
    description: "喜欢反转与推理的你不能错过，悬疑、犯罪、谍战一网打尽，每一帧都暗藏线索，考验你的观察力。",
    cover: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20corridor%20with%20a%20single%20glowing%20door%20and%20fog%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20suspenseful%20lighting%2C%20film%20grain%2C%20no%20text&width=1200&height=700&seq=qx-special-s4&orientation=landscape",
    color: "secondary",
  },
  {
    id: "s5",
    title: "青春成长物语",
    subtitle: "热泪与梦想 · 不负少年时",
    description: "关于梦想、友情与成长的故事合集，献给每一个仍在奔跑的你，愿你我都曾拥有那样滚烫的青春。",
    cover: "https://readdy.ai/api/search-image?query=Youthful%20cinematic%20scene%20of%20friends%20on%20a%20rooftop%20at%20dusk%20with%20city%20lights%2C%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20inspiring%20lighting%2C%20film%20grain%2C%20no%20text&width=1200&height=700&seq=qx-special-s5&orientation=landscape",
    color: "accent",
  },
];